import { render, staticRenderFns } from "./sys_teacherDept.vue?vue&type=template&id=49453402&scoped=true"
import script from "./sys_teacherDept.vue?vue&type=script&lang=js"
export * from "./sys_teacherDept.vue?vue&type=script&lang=js"
import style0 from "./sys_teacherDept.vue?vue&type=style&index=0&id=49453402&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49453402",
  null
  
)

export default component.exports